import { n as EEvent } from './request.constants-deb285e0.js';
import { s as sendEvent } from './utils-15ad90ec.js';

const isApc$1 = Boolean(window.isApc);
const makeId = (length = 5) => {
  let text = '';
  const possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};
const getComparisonSessionId = () => {
  const seSessionId = 'COMPARISON_SESSION_ID';
  const apcSessionId = 'APC_COMPARISON_SESSION_ID';
  const COMPARISON_SESSION_ID = !isApc$1 ? seSessionId : apcSessionId;
  let sessionId = localStorage.getItem(COMPARISON_SESSION_ID);
  if (!sessionId) {
    sessionId = makeId();
    localStorage.setItem(COMPARISON_SESSION_ID, sessionId);
  }
  return sessionId;
};
const getComparatorThreshold = () => {
  const comparatorThreshold = parseInt(window.comparatorThreshold);
  return isNaN(comparatorThreshold) ? undefined : comparatorThreshold;
};
const COMPARATOR_LOCALE = document.documentElement.lang.replace('-', '_');
const getStorageComparatorName = () => {
  if (!isApc$1) {
    return `pesProductComparisonList_${COMPARATOR_LOCALE}`;
  }
  return 'comparisonList';
};

const isApc = Boolean(window.isApc);
const MAX_COMPARATOR_ITEMS = getComparatorThreshold();
const BACK_TO_RESULTS_LINK = 'pesBackLink';
const STORAGE_COMPARATOR_NAME = getStorageComparatorName();
const PRODUCT_IDS_SEPARATOR = ',';
class Comparator {
  constructor() {
    this.handleCompareControlClick = (event) => {
      const productId = typeof event.detail === 'string' ? event.detail : event.detail.repositoryId;
      if (this.has(productId)) {
        this.remove(productId);
      }
      else if (!this.isFull()) {
        this.add(productId);
      }
      else {
        return;
      }
      this.notifySubscribers();
    };
    this.handleStorageChange = (event) => {
      if (event.key === STORAGE_COMPARATOR_NAME) {
        this.notifySubscribers();
      }
    };
    this.setListeners();
    if (!isApc) {
      this.setBackLink();
    }
  }
  setListeners() {
    window.addEventListener(EEvent.COMPARE_CONTROL_CLICK, this.handleCompareControlClick);
    window.addEventListener('storage', this.handleStorageChange);
  }
  setBackLink() {
    window.localStorage.setItem(`${COMPARATOR_LOCALE}-${BACK_TO_RESULTS_LINK}`, window.location.href);
  }
  getBackLink() {
    return window.localStorage.getItem(`${COMPARATOR_LOCALE}-${BACK_TO_RESULTS_LINK}`) || '';
  }
  getStoredProductIds() {
    var _a;
    const serializedList = (_a = localStorage.getItem(STORAGE_COMPARATOR_NAME)) !== null && _a !== void 0 ? _a : '';
    if (!isApc) {
      return serializedList.split(PRODUCT_IDS_SEPARATOR).filter(Boolean);
    }
    let result = [];
    try {
      result = JSON.parse(serializedList);
    }
    finally {
      return result;
    }
  }
  store(productIds) {
    let serializedList;
    if (!isApc) {
      serializedList = productIds.join(PRODUCT_IDS_SEPARATOR);
    }
    else {
      serializedList = JSON.stringify(productIds);
    }
    localStorage.setItem(STORAGE_COMPARATOR_NAME, serializedList);
  }
  has(productId) {
    return this.getStoredProductIds().includes(productId);
  }
  add(productId) {
    const productIds = [...this.getStoredProductIds(), productId];
    this.store(productIds);
  }
  remove(productId) {
    const productIds = this.getStoredProductIds();
    this.store(productIds.filter((id) => productId !== id));
  }
  isFull() {
    if (MAX_COMPARATOR_ITEMS) {
      return this.getStoredProductIds().length >= MAX_COMPARATOR_ITEMS;
    }
    return false;
  }
  get value() {
    return {
      list: this.getStoredProductIds(),
      isFull: this.isFull(),
      productProp: 'repositoryId',
    };
  }
  notifySubscribers() {
    sendEvent(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.value);
  }
  removeAll() {
    localStorage.removeItem(STORAGE_COMPARATOR_NAME);
    this.notifySubscribers();
  }
}
const comparator = new Comparator();

export { MAX_COMPARATOR_ITEMS as M, comparator as c, getComparisonSessionId as g, isApc$1 as i };
